/** Скорость анимаций на Яндекс Картах */
export const MAP_ANIMATION_DURATION_IN_MS: number = 200
